module.exports = __webpack_public_path__ + "static/media/user-tag.6f550b67.svg";